import React from "react";
import "./Common_Vendor_Cards_History_Onlogin.css";

const Common_Vendor_Cards_History_Onlogin = ({ data }) => {
  if (!data) return null;

  return (
    <div className="expert-list-card">
      <div className="expert-list-card__container">
        <div className="expert-list-card__image-box">
          <img
            src={data.image}
            alt={data.name}
            className="expert-list-card__img"
          />
        </div>
        <div className="expert-list-card__content">
          <p className="expert-list-card__name">{data.name}</p>

          <div className="expert-list-card__details">
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Mobile No:-</span>
              <span className="expert-list-card__value">{data.mobile_no}</span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Whatsapp No:-</span>
              <span className="expert-list-card__value">
                {data.whatsapp_no}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">City:-</span>
              <span className="expert-list-card__value">{data.city}</span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">State:-</span>
              <span className="expert-list-card__value">{data.state}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Common_Vendor_Cards_History_Onlogin;
